import React, { Component } from 'react';

export default class ViewingTime extends Component {
  get classes() {
    const classes = ['book-a-viewing__time_choice', 'time'];

    if (this.props.selected) {
      classes.push('selected');
    }

    return classes.join(' ');
  }

  handleClick = (e) => {
    e.preventDefault();
    track_event('booking-time', 'clicked', 'bookings');

    this.props.onClick(e);
  };

  render() {
    const time = this.props.time;

    if (time.isDisabled) {
      return (
        <a
          id={`time-${time.utcTimestamp}`}
          data-label={time.timeLabel}
          data-datetime={time.utcTimestamp}
          className="book-a-viewing__time-choice time disabled"
          href="#"
        >
          <span className="text">Booked</span>
        </a>
      );
    } else {
      return (
        <a
          id={`time-${time.utcTimestamp}`}
          data-label={time.timeLabel}
          data-datetime={time.utcTimestamp}
          data-ga-category="home-viewing-flow"
          data-ga-action="select-viewing-time"
          data-ga-label={time.timeLabel}
          className={this.classes}
          href="#"
          onClick={this.handleClick}
        >
          <span className="number">{time.textLabel}</span>
        </a>
      );
    }
  }
}
